import { Injectable } from '@angular/core';
import { RCSSuggestionTypeStats } from '../models/rcs-suggestion-type-stats.model';

@Injectable({ providedIn: 'root' })
export class RCSSuggestionTypeStatsAdapter {
  adapt(item: any): RCSSuggestionTypeStats {
    const stats = new RCSSuggestionTypeStats();
    stats.suggestionType = item.SuggestionType || item.suggestionType;
    stats.totalSuggestions = item.TotalSuggestions || item.totalSuggestions || 0;
    stats.totalClicks = item.TotalClicks || item.totalClicks || 0;
    stats.interactionPercentage = item.InteractionPercentage || item.interactionPercentage || 0;
    return stats;
  }
}
